import { BarChartIcon, NoRowsOverlay } from '@shared/components';

export default function AdminQuestionnaireEmptyStateOverlay() {
  return (
    <NoRowsOverlay
      icon={BarChartIcon}
      title='ยังไม่มีข้อมูลให้แสดง'
      description='โปรดเลือกตัวกรองด้านบนก่อน เพื่อดูข้อมูลรายงานตามช่วงวันที่หรือเงื่อนไขที่ต้องการ'
    />
  );
}
